/** Notifications éphémères. */
import { el } from './dom.js';

let container;
function ensure() {
  if (!container) {
    container = el('div', { class: 'toasts' });
    document.body.appendChild(container);
  }
  return container;
}

export function toast(message, kind = 'info') {
  const node = el(
    'div',
    { class: 'toast' + (kind === 'err' ? ' err' : '') },
    el('span', { class: 'dot', style: kind === 'err' ? { background: '#ff7a7a' } : {} }),
    message
  );
  ensure().appendChild(node);
  setTimeout(() => {
    node.style.transition = 'opacity .3s, transform .3s';
    node.style.opacity = '0';
    node.style.transform = 'translateY(10px)';
    setTimeout(() => node.remove(), 320);
  }, kind === 'err' ? 4200 : 2600);
}
